import React, {useEffect, useState} from 'react'
import {useParams, useLocation} from 'react-router-dom'
import {PDFViewer} from '@react-pdf/renderer'
import DopPdfDocument from './DopPdfDocument'

import {fetchPanelDop, getAllDopItems} from '../../../../api/paneliDop'
import {
    distinctDebljinaForTipAndIzolacija,
    getSifraDetails
} from '../../../../api/paneliSifre'
import {postojiLiNalogUpisan} from "../../../../api/proizvodnja";

const DopPdfPage = () => {
    const {id} = useParams()
    const location = useLocation()

    const searchParams = new URLSearchParams(location.search)
    const brojNaloga = searchParams.get('brojNaloga')
    const rawSifra = searchParams.get('sifraArtikla')

    const sifraArtikla = rawSifra
        ? decodeURIComponent(rawSifra).replace(/[}\s]+$/, '').trim()
        : null

    const stavka = searchParams.get('stavka')

    const [data, setData] = useState<any>(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!id) return

        const load = async () => {
            try {
                setLoading(true)

                // 🔹 1. Fetch DOP
                const dopData = await fetchPanelDop(Number(id))

                // 🔹 2. Fetch items
                const items = await getAllDopItems()
                const dopItems = Array.isArray(items) ? items : items?.data

                // 🔹 3. Fetch debljine
                let debljine: string[] = []

                if (dopData?.dop?.TipPanela && dopData?.dop?.Izolacija) {
                    const deb = await distinctDebljinaForTipAndIzolacija(
                        dopData.dop.TipPanela,
                        String(dopData.dop.Izolacija)
                    )

                    const list = Array.isArray(deb) ? deb : deb?.data
                    debljine = (list || []).map((d: any) => String(d.debljina))
                }

                // 🔹 4. Fetch debljine limova
                let debljineLimova: any = null

                // ✅ PRIORITY 1 → sifra from URL
                if (sifraArtikla) {

                    const response = await getSifraDetails(sifraArtikla)

                    debljineLimova = response?.data || response || null
                }
                // ✅ PRIORITY 2 → derive from nalog
                else if (brojNaloga) {
                    console.log('➡️ brojNaloga:', brojNaloga)

                    const parsedStavka =
                        stavka && !isNaN(Number(stavka)) ? Number(stavka) : undefined

                    const nalogData = await postojiLiNalogUpisan(
                        brojNaloga,
                        parsedStavka
                    )

                    console.log('➡️ nalogData:', nalogData)

                    const sifraFromNalog = nalogData?.data?.[0]?.artikal

                    if (sifraFromNalog) {
                        console.log('➡️ sifraFromNalog:', sifraFromNalog)

                        const response = await getSifraDetails(sifraFromNalog)

                        debljineLimova = response?.data || response || null
                    } else {
                        console.log('❌ sifraFromNalog missing')
                    }
                }

                console.log('✅ FINAL debljineLimova:', debljineLimova)

                // 🔹 5. Final state
                setData({
                    dop: dopData?.dop,
                    matrix: dopData?.matrix,
                    dopItems,
                    debljine,
                    debljineLimova
                })

            } catch (error) {
                console.error('❌ Error loading DOP PDF data:', error)
            } finally {
                setLoading(false)
            }
        }

        load()
    }, [id, brojNaloga, stavka, sifraArtikla])

    if (loading || !data) {
        return <div className='p-10 text-center'>Učitavanje...</div>
    }

    return (
        <PDFViewer width="100%" height="900">
            <DopPdfDocument {...data} />
        </PDFViewer>
    )
}

export default DopPdfPage